module.exports = __webpack_public_path__ + "img/loading_cover.ea614ea3.jpg";